import { toLower } from 'lodash';
import { v4 as uuid } from 'uuid';
import moment from 'moment-timezone';
import { isNotNullOrUndefined, isObjectNotEmpty, isStringNotEmpty } from '../utils/objectUtils';
import AffiliateInfo from './AffiliateInfo';

class AttributionHistoryItem {
    id = uuid();
    type = null; // INITIAL, SESSION, COUPON_REFERRAL, CHECKOUT_OVERRIDE, LEAD_BACKFILL
    reason = null;
    source = null; // tracking_service, checkout, lead_backfill
    affiliateInfo = null;
    siteVisitId = null;
    couponCode = null;
    previousAffiliateId = null;
    previousSubAffiliateId = null;
    affiliateId = null;
    subAffiliateId = null;
    occurredAt = moment().utc().toDate();

    constructor(item) {
        if (isObjectNotEmpty(item)) {
            if (isStringNotEmpty(item.id)) { this.id = item.id; }
            if (isStringNotEmpty(item.type)) { this.type = item.type; }
            if (isStringNotEmpty(item.reason)) { this.reason = item.reason; }
            if (isStringNotEmpty(item.source)) { this.source = item.source; }
            if (isObjectNotEmpty(item.affiliateInfo)) { this.affiliateInfo = new AffiliateInfo(item.affiliateInfo).toDto(); }
            if (isStringNotEmpty(item.siteVisitId)) { this.siteVisitId = item.siteVisitId; }
            if (isStringNotEmpty(item.couponCode)) { this.couponCode = toLower(item.couponCode); }
            if (isStringNotEmpty(item.previousAffiliateId)) { this.previousAffiliateId = toLower(item.previousAffiliateId); }
            if (isStringNotEmpty(item.previousSubAffiliateId)) { this.previousSubAffiliateId = toLower(item.previousSubAffiliateId); }
            if (isStringNotEmpty(item.affiliateId)) { this.affiliateId = toLower(item.affiliateId); }
            else if (isStringNotEmpty(item.affiliateInfo?.affiliateId)) { this.affiliateId = toLower(item.affiliateInfo.affiliateId); }
            if (isStringNotEmpty(item.subAffiliateId)) { this.subAffiliateId = toLower(item.subAffiliateId); }
            else if (isStringNotEmpty(item.affiliateInfo?.subAffiliateId)) { this.subAffiliateId = toLower(item.affiliateInfo.subAffiliateId); }
            if (isNotNullOrUndefined(item.occurredAt)) { this.occurredAt = item.occurredAt; }
        }
    }

    toDto = () => ({
        id: this.id,
        type: this.type,
        reason: this.reason,
        source: this.source,
        affiliateInfo: this.affiliateInfo,
        siteVisitId: this.siteVisitId,
        couponCode: this.couponCode,
        previousAffiliateId: this.previousAffiliateId,
        previousSubAffiliateId: this.previousSubAffiliateId,
        affiliateId: this.affiliateId,
        subAffiliateId: this.subAffiliateId,
        occurredAt: this.occurredAt
    });
}

export default AttributionHistoryItem;
